import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  headerSection: {
    p: ['64px 0 41px', '64px 0 41px', '128px 0 41px', '208px 10.15625vw 41px'],
    borderBottom: `1px solid ${theme.rawColors.lightGrey500}`,
    overflow: 'hidden',
    maxWidth: '100%'
  },
  inspirationNav: {
    display: 'flex',
    flexWrap: 'wrap',
    p: '16px 0',
    pl: ['10.6666667vw', '10.6666667vw', '8.33333333vw', 0],
    alignItems: 'flex-end',
    maxWidth: '100%'
  },
  inspirationLink: (active?: boolean) => ({
    width: [active && '100%', active && '100%', active && '100%', 'unset'],
    p: '2px 40px 3px 0',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    order: [active ? 0 : 1, active ? 0 : 1, active ? 1 : 'none', 'none'],
    'p.subtitle': {
      pb: ['8px', '8px', '14px', '24px'],
      lineHeight: '140%',
      fontSize: theme.fontSizes.text,
      color: theme.rawColors.darkGrey700
    },
    'h1.display__five.mobile': {
      width: ['min-content', 'min-content', 'min-content', 'auto'],
      fontSize: [theme.fontSizes.displayMobile, theme.fontSizes.displayMobile, theme.fontSizes.mediumHeading, theme.fontSizes.displayFive]
    },
    h6: {
      mb: [0, 0, 0, '24px'],
      mt: [16, 16, 16, 0],
      width: 'max-content',
      textTransform: 'lowercase',
      borderBottom: '1px solid transparent',
      ...reusables.mainTransition('border-color'),
      '&:hover': {
        borderBottom: `1px solid ${active ? 'transparent' : theme.rawColors.darkGrey700}`
      }
    }
  }),
  tagsContainer: {
    display: 'flex',
    flexWrap: ['nowrap', 'nowrap', 'nowrap', 'wrap'],
    gap: 24,
    overflowX: 'auto',
    maxWidth: '100%',
    width: '100%',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
      display: 'none'
    },
    pl: ['10.6666667vw', '10.6666667vw', '8.33333333vw', 0],
    pr: ['10.6666667vw', '10.6666667vw', '8.33333333vw', 0]
  },
  button: {
    margin: '4px 4px'
  }
};